import Input from "../../../components/Input"
import { Box, Button, Chip, Grid, Stack} from "@mui/material"
import DateYearSelect from "../../../components/DateYearSelect"

const Education = ({fieldValues, handleIndexedOnChange, handleAddNew, handleDelete, handleDateField}) => {
    const fields = [
        {name:'school_name', label:'School Name', type: 'input'},
        {name:'school_location', label:'School Location', type: 'input'},
        {name:'degree', label:'Degree', type: 'input'},
        {name:'field_of_study', label:'Field of Study', type: 'input'},
        {name:'start_date', label:'Start Date', type: 'date'},
        {name:'end_date', label:'End Date', type: 'date'},
    ]

    const handleOnChange = (name, value, index) =>{
        handleIndexedOnChange('education', index, name, value)
    }

    const handleDate = (name, value, index, key) =>{
        handleDateField('education', index, name, value, key)
    }

    return <Grid container>
        <Grid item xs={12} px={3} display={'flex'} justifyContent={'space-between'}>
        <Stack direction="row" spacing={1}>{fieldValues['education'].map((values, index)=>{
                return <Chip label={`Education ${index + 1}`} onDelete={()=>handleDelete('education', index)}/>
            })}</Stack>
            <Box><Button variant="contained" onClick={()=>handleAddNew('education')}>Add New</Button></Box>
        </Grid>
        {fieldValues['education'].map((values, fieldIndex)=>{
            return fields.map((field, index)=>{
                return <Grid item xs={6} p={3}>
                    {field.type === 'date' && <DateYearSelect label={field.label} fieldValues={fieldValues} value={values[field.name]} index={fieldIndex} name={field.name}  handleOnChange={handleDate} yearOnly={true} /> }
                    {field.type === 'input' && <Input name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} handleOnChange={handleOnChange} yearOnly={true}/>}
                </Grid>
            })
        })}
    </Grid>
}

export default Education